// ========================================
// AUDITORIA MODULE
// ========================================
// Unified audit trail for all system activities

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.Auditoria = {
    eventos: [],
    limite: 100,
    filtros: {
        periodo: 'hoje',
        tipo: 'todos',
        busca: ''
    },

    render: async function (container) {
        if (!container) container = document.getElementById('main-content');

        const styles = `
            <style>
                .audit-page {
                    padding: 20px;
                    max-width: 1400px;
                    margin: 0 auto;
                }
                .audit-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 30px;
                }
                .audit-header h1 {
                    font-size: 1.8rem;
                    color: #1e293b;
                    margin: 0;
                }
                .audit-stats {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 15px;
                    margin-bottom: 25px;
                }
                .audit-stat-card {
                    background: white;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }
                .audit-stat-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                }
                .audit-stat-info .label {
                    font-size: 0.85rem;
                    color: #64748b;
                    margin-bottom: 5px;
                }
                .audit-stat-info .value {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #1e293b;
                }
                .audit-filters {
                    background: white;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    margin-bottom: 20px;
                    display: flex;
                    gap: 15px;
                    flex-wrap: wrap;
                    align-items: center;
                }
                .audit-filter-group {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }
                .audit-filter-group label {
                    font-size: 0.85rem;
                    color: #64748b;
                    font-weight: 600;
                }
                .audit-filter-group select,
                .audit-filter-group input {
                    padding: 8px 12px;
                    border: 1px solid #e2e8f0;
                    border-radius: 6px;
                    font-size: 0.9rem;
                }
                .audit-timeline {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    padding: 25px;
                }
                .audit-event {
                    display: flex;
                    gap: 20px;
                    padding: 20px;
                    border-left: 3px solid #e2e8f0;
                    margin-bottom: 15px;
                    position: relative;
                    background: #f8fafc;
                    border-radius: 8px;
                    transition: all 0.2s;
                }
                .audit-event:hover {
                    border-left-color: #4f46e5;
                    background: #fff;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                }
                .audit-event-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.3rem;
                    flex-shrink: 0;
                }
                .audit-event-content {
                    flex: 1;
                }
                .audit-event-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: start;
                    margin-bottom: 8px;
                }
                .audit-event-title {
                    font-size: 1rem;
                    font-weight: 600;
                    color: #1e293b;
                    margin-bottom: 5px;
                }
                .audit-event-desc {
                    font-size: 0.9rem;
                    color: #64748b;
                    margin-bottom: 10px;
                }
                .audit-event-meta {
                    display: flex;
                    gap: 15px;
                    font-size: 0.85rem;
                    color: #94a3b8;
                    flex-wrap: wrap;
                }
                .audit-event-meta span {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
                .audit-event-timestamp {
                    font-size: 0.85rem;
                    color: #94a3b8;
                }
                .audit-event-actions {
                    display: flex;
                    gap: 8px;
                    margin-top: 10px;
                }
                .audit-btn {
                    padding: 6px 12px;
                    border-radius: 5px;
                    border: 1px solid #e2e8f0;
                    background: white;
                    color: #64748b;
                    font-size: 0.85rem;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                }
                .audit-btn:hover {
                    background: #4f46e5;
                    color: white;
                    border-color: #4f46e5;
                }
                .audit-no-data {
                    text-align: center;
                    padding: 60px 20px;
                    color: #94a3b8;
                }
                .audit-loading {
                    text-align: center;
                    padding: 40px;
                    color: #94a3b8;
                }
            </style>
        `;

        container.innerHTML = `
            ${styles}
            <div class="audit-page">
                <div class="audit-header">
                    <h1><i class="fas fa-clipboard-list"></i> Auditoria do Sistema</h1>
                </div>

                <!-- Stats -->
                <div class="audit-stats" id="audit-stats">
                    <div class="audit-stat-card">
                        <div class="audit-stat-icon" style="background:#f0f9ff; color:#0284c7;">
                            <i class="fas fa-list"></i>
                        </div>
                        <div class="audit-stat-info">
                            <div class="label">Total de Eventos</div>
                            <div class="value" id="stat-total">-</div>
                        </div>
                    </div>
                    <div class="audit-stat-card">
                        <div class="audit-stat-icon" style="background:#f0fdf4; color:#16a34a;">
                            <i class="fas fa-dollar-sign"></i>
                        </div>
                        <div class="audit-stat-info">
                            <div class="label">Lançamentos</div>
                            <div class="value" id="stat-lancamentos">-</div>
                        </div>
                    </div>
                    <div class="audit-stat-card">
                        <div class="audit-stat-icon" style="background: #eff6ff; color: #3b82f6;">
                            <i class="fas fa-university"></i>
                        </div>
                        <div class="audit-stat-info">
                            <div class="label">Movimentações</div>
                            <div class="value" id="stat-movimentacoes">-</div>
                        </div>
                    </div>
                    <div class="audit-stat-card">
                        <div class="audit-stat-icon" style="background:#f5f3ff; color:#7c3aed;">
                            <i class="fas fa-boxes"></i>
                        </div>
                        <div class="audit-stat-info">
                            <div class="label">Estoque</div>
                            <div class="value" id="stat-estoque">-</div>
                        </div>
                    </div>
                    <div class="audit-stat-card">
                        <div class="audit-stat-icon" style="background:#fef2f2; color:#ef4444;">
                            <i class="fas fa-gas-pump"></i>
                        </div>
                        <div class="audit-stat-info">
                            <div class="label">Abastecimentos</div>
                            <div class="value" id="stat-abastecimentos">-</div>
                        </div>
                    </div>
                </div>

                <!-- Filters -->
                <div class="audit-filters">
                    <div class="audit-filter-group">
                        <label>Período</label>
                        <select id="filter-periodo" onchange="window.FazendaRP.Pages.Auditoria.aplicarFiltros()">
                            <option value="hoje">Hoje</option>
                            <option value="semana">Esta Semana</option>
                            <option value="mes" selected>Este Mês</option>
                            <option value="tudo">Tudo</option>
                        </select>
                    </div>
                    <div class="audit-filter-group">
                        <label>Tipo</label>
                        <select id="filter-tipo" onchange="window.FazendaRP.Pages.Auditoria.aplicarFiltros()">
                            <option value="todos">Todos os Tipos</option>
                            <option value="lancamento">💰 Lançamentos</option>
                            <option value="movimentacao">🏦 Movimentações</option>
                            <option value="estoque">📦 Estoque</option>
                            <option value="abastecimento">⛽ Abastecimentos</option>
                        </select>
                    </div>
                    <div class="audit-filter-group" style="flex: 1;">
                        <label>Buscar</label>
                        <input type="text" id="filter-busca" placeholder="Descrição, valor, parceiro..." oninput="window.FazendaRP.Pages.Auditoria.aplicarFiltros()" />
                    </div>
                </div>

                <!-- Timeline -->
                <div class="audit-timeline" id="audit-timeline">
                    <div class="audit-loading">
                        <i class="fas fa-spinner fa-spin"></i> Carregando eventos...
                    </div>
                </div>
            </div>
        `;

        await this.carregarEventos();
    },

    carregarEventos: async function () {
        try {
            const timeline = document.getElementById('audit-timeline');
            timeline.innerHTML = '<div class="audit-loading"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>';

            // Buscar lançamentos financeiros
            const { data: lancamentos } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .order('created_at', { ascending: false })
                .limit(this.limite);

            // Buscar transferências
            const { data: transferencias } = await window.FazendaRP.supabase
                .from('financeiro_movimentacoes')
                .select('*')
                .order('created_at', { ascending: false })
                .limit(this.limite);

            // Consolidar eventos
            this.eventos = [];

            // Processar lançamentos
            if (lancamentos) {
                lancamentos.forEach(l => {
                    const detalhes = l.detalhes || {};
                    this.eventos.push({
                        tipo: 'lancamento',
                        timestamp: l.created_at,
                        id: l.id,
                        titulo: `Lançamento ${l.tipo}`,
                        descricao: l.descricao || 'Sem descrição',
                        valor: l.valor,
                        meta: {
                            tipo: l.tipo,
                            categoria: l.categoria,
                            parceiro: l.parceiros ? l.parceiros.nome : null,
                            status: l.status,
                            conta_id: l.conta_id,
                            num_doc: detalhes.num_doc || null,
                            criador: this.identificarCriador(l)
                        }
                    });
                });
            }

            // Processar movimentações
            if (transferencias) {
                transferencias.forEach(t => {
                    this.eventos.push({
                        tipo: 'movimentacao',
                        timestamp: t.created_at,
                        id: t.id,
                        titulo: 'Movimentação Bancária',
                        descricao: t.historico || 'Movimentação',
                        valor: t.valor,
                        meta: {
                            tipo: t.tipo,
                            conta_id: t.conta_id,
                            status: t.status,
                            criador: 'Sistema'
                        }
                    });
                });
            }

            // Buscar movimentações de estoque (Corrigido para suprimentos_movimentacoes)
            const { data: estoque } = await window.FazendaRP.supabase
                .from('suprimentos_movimentacoes')
                .select('*')
                .order('data_movimentacao', { ascending: false })
                .limit(this.limite);

            // Processar estoque
            if (estoque) {
                estoque.forEach(e => {
                    const valorEstimado = (e.quantidade || 0) * (e.custo_unitario || 0);
                    this.eventos.push({
                        tipo: 'estoque',
                        timestamp: e.data_movimentacao || e.created_at,
                        id: e.id,
                        titulo: `Estoque ${e.tipo}`,
                        descricao: e.item_nome || 'Item do Estoque',
                        valor: valorEstimado > 0 ? valorEstimado : null,
                        meta: {
                            tipo: e.tipo,
                            quantidade: e.quantidade,
                            unidade: 'UN', // Padrão da tabela
                            observacao: e.observacao,
                            criador: e.origem_tipo === 'sistema' ? 'Sistema' : 'Manual'
                        }
                    });
                });
            }

            // Buscar abastecimentos (ajustado para schema correto)
            const { data: abastecimentos } = await window.FazendaRP.supabase
                .from('maquinas_abastecimentos')
                .select('*, frota(nome, placa)')
                .order('data', { ascending: false })
                .limit(this.limite);

            // Processar abastecimentos
            if (abastecimentos) {
                abastecimentos.forEach(a => {
                    const maquinaInfo = a.frota ? (a.frota.nome || a.frota.placa) : 'Máquina';
                    this.eventos.push({
                        tipo: 'abastecimento',
                        timestamp: a.data,
                        id: a.id,
                        titulo: 'Abastecimento',
                        descricao: `${maquinaInfo} - ${a.combustivel || 'Diesel'}`,
                        valor: a.valor_total || null,
                        meta: {
                            tipo: a.combustivel,
                            litros: a.litros,
                            maquina: maquinaInfo,
                            hodometro: a.hodometro,
                            criador: 'Manual'
                        }
                    });
                });
            }

            // Ordenar por data
            this.eventos.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

            this.aplicarFiltros();
            this.atualizarStats();

        } catch (err) {
            console.error('Erro ao carregar eventos:', err);
            document.getElementById('audit-timeline').innerHTML = '<div class="audit-no-data"><i class="fas fa-exclamation-triangle"></i> Erro ao carregar eventos</div>';
        }
    },

    identificarCriador: function (lancamento) {
        // Verificar se veio do WhatsApp Bot
        if (lancamento.descricao && (lancamento.descricao.includes('Bot') || lancamento.descricao.includes('WhatsApp'))) {
            return 'WhatsApp Bot';
        }

        // Verificar detalhes
        const detalhes = lancamento.detalhes || {};
        if (detalhes.origem === 'whatsapp' || detalhes.pre_lancamento_id) {
            return 'WhatsApp Bot';
        }

        // Verificar se é transferência
        if (lancamento.descricao && lancamento.descricao.includes('TRF')) {
            return 'Sistema';
        }

        return 'Manual';
    },

    aplicarFiltros: function () {
        const periodo = document.getElementById('filter-periodo').value;
        const tipo = document.getElementById('filter-tipo').value;
        const busca = document.getElementById('filter-busca').value.toLowerCase();

        let filtrados = [...this.eventos];

        // Filtro de período
        const now = new Date();
        if (periodo === 'hoje') {
            filtrados = filtrados.filter(e => {
                const d = new Date(e.timestamp);
                return d.toDateString() === now.toDateString();
            });
        } else if (periodo === 'semana') {
            const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            filtrados = filtrados.filter(e => new Date(e.timestamp) >= weekAgo);
        } else if (periodo === 'mes') {
            const monthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
            filtrados = filtrados.filter(e => new Date(e.timestamp) >= monthAgo);
        }

        // Filtro de tipo
        if (tipo !== 'todos') {
            filtrados = filtrados.filter(e => e.tipo === tipo);
        }

        // Filtro de busca
        if (busca) {
            filtrados = filtrados.filter(e => {
                return e.descricao.toLowerCase().includes(busca) ||
                    e.titulo.toLowerCase().includes(busca) ||
                    (e.valor && e.valor.toString().includes(busca)) ||
                    (e.meta.parceiro && e.meta.parceiro.toLowerCase().includes(busca));
            });
        }

        this.renderizarTimeline(filtrados);
    },

    renderizarTimeline: function (eventos) {
        const timeline = document.getElementById('audit-timeline');

        if (eventos.length === 0) {
            timeline.innerHTML = '<div class="audit-no-data"><i class="fas fa-inbox"></i><br>Nenhum evento encontrado</div>';
            return;
        }

        const html = eventos.slice(0, 50).map(e => this.renderEvento(e)).join('');

        // Botão "Carregar Mais" se houver mais eventos do que o limite atual
        const btnCarregarMais = this.eventos.length >= this.limite ? `
            <div style="text-align: center; padding: 20px;">
                <button class="audit-btn" onclick="window.FazendaRP.Pages.Auditoria.carregarMais()" style="padding: 10px 20px; font-size: 1rem;">
                    <i class="fas fa-plus-circle"></i> Carregar Mais 100 Eventos
                </button>
            </div>
        ` : '';

        timeline.innerHTML = html + btnCarregarMais;
    },

    renderEvento: function (evento) {
        const iconMap = {
            'lancamento': { icon: 'fa-file-invoice-dollar', color: '#10b981', bg: '#f0fdf4' },
            'movimentacao': { icon: 'fa-university', color: '#3b82f6', bg: '#eff6ff' }, // Azul para movimentações
            'estoque': { icon: 'fa-boxes', color: '#8b5cf6', bg: '#f5f3ff' },
            'abastecimento': { icon: 'fa-gas-pump', color: '#ef4444', bg: '#fef2f2' }
        };

        const config = iconMap[evento.tipo] || iconMap['lancamento'];
        const timestamp = new Date(evento.timestamp);
        const relativeTime = this.getRelativeTime(timestamp);

        const valorFmt = evento.valor ? parseFloat(evento.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '';

        return `
            <div class="audit-event" style="border-left-color: ${config.color};">
                <div class="audit-event-icon" style="background: ${config.bg}; color: ${config.color};">
                    <i class="fas ${config.icon}"></i>
                </div>
                <div class="audit-event-content">
                    <div class="audit-event-header">
                        <div>
                            <div class="audit-event-title">${evento.titulo}</div>
                            <div class="audit-event-desc">${evento.descricao}</div>
                        </div>
                        <div class="audit-event-timestamp">${relativeTime}</div>
                    </div>
                    <div class="audit-event-meta">
                        ${evento.meta.num_doc ? `<span><i class="fas fa-file-alt"></i> <strong>${evento.meta.num_doc}</strong></span>` : ''}
                        ${valorFmt ? `<span><i class="fas fa-dollar-sign"></i> ${valorFmt}</span>` : ''}
                        ${evento.meta.quantidade ? `<span><i class="fas fa-boxes"></i> ${evento.meta.quantidade} ${evento.meta.unidade || 'un'}</span>` : ''}
                        ${evento.meta.litros ? `<span><i class="fas fa-gas-pump"></i> ${evento.meta.litros}L</span>` : ''}
                        ${evento.meta.maquina ? `<span><i class="fas fa-tractor"></i> ${evento.meta.maquina}</span>` : ''}
                        ${evento.meta.parceiro ? `<span><i class="fas fa-user"></i> ${evento.meta.parceiro}</span>` : ''}
                        ${evento.meta.categoria ? `<span><i class="fas fa-tag"></i> ${evento.meta.categoria}</span>` : ''}
                        ${evento.meta.status ? `<span><i class="fas fa-info-circle"></i> ${evento.meta.status}</span>` : ''}
                        <span><i class="fas fa-user-circle"></i> <strong>${evento.meta.criador}</strong></span>
                    </div>
                    <div class="audit-event-actions">
                        <button class="audit-btn" onclick="window.FazendaRP.Pages.Auditoria.verDetalhes('${evento.tipo}', '${evento.id}')">
                            <i class="fas fa-eye"></i> Ver Detalhes
                        </button>
                    </div>
                </div>
            </div>
        `;
    },

    getRelativeTime: function (date) {
        const now = new Date();
        const diff = now - date;
        const seconds = Math.floor(diff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (seconds < 60) return 'Agora mesmo';
        if (minutes < 60) return `${minutes}min atrás`;
        if (hours < 24) return `${hours}h atrás`;
        if (days === 1) return 'Ontem';
        if (days < 7) return `${days} dias atrás`;
        return date.toLocaleDateString('pt-BR');
    },

    atualizarStats: function () {
        const total = this.eventos.length;
        const lancamentos = this.eventos.filter(e => e.tipo === 'lancamento').length;
        const movimentacoes = this.eventos.filter(e => e.tipo === 'movimentacao').length;
        const estoque = this.eventos.filter(e => e.tipo === 'estoque').length;
        const abastecimentos = this.eventos.filter(e => e.tipo === 'abastecimento').length;

        document.getElementById('stat-total').innerText = total;
        document.getElementById('stat-lancamentos').innerText = lancamentos;
        document.getElementById('stat-movimentacoes').innerText = movimentacoes;
        document.getElementById('stat-estoque').innerText = estoque;
        document.getElementById('stat-abastecimentos').innerText = abastecimentos;
    },

    verDetalhes: async function (tipo, id) {
        if (tipo === 'lancamento') {
            // Navegar para lançamentos e abrir detalhes
            if (window.FazendaRP.LancamentosCRUD && window.FazendaRP.LancamentosCRUD.loadLancamentoForEdit) {
                await window.FazendaRP.LancamentosCRUD.loadLancamentoForEdit(id, { readOnly: true });
            }
        } else if (tipo === 'movimentacao') {
            // Redirecionar para o módulo financeiro (extrato)
            window.location.hash = '#financeiro/movimentacoes';
        }
    },

    carregarMais: async function () {
        this.limite += 100;
        window.FazendaRP.Toast.show('info', 'Carregando...', `Buscando mais ${this.limite} eventos...`);
        await this.carregarEventos();
    }
};
